import {
  AnalyticsEvent,
  AnalyticsEvents,
  ConstructorAnalyticsEvent,
  EventInfo,
} from '@o3r/analytics';

/**
 * Event raised when exit button is clicked and the user is redirected with the actual deep-link
 */
export class ExitLinkWithDeepLink implements AnalyticsEvent {
  /* @inheritDoc */
  public eventInfo: EventInfo = {
    key: 'exitlink-deeplink',
    eventName: 'Exit link from SelfReaccommodation'
  };
}

/**
 * Event raised when exit button is clicked and the user is redirected with the fallback link
 */
export class ExitLinkWithFallbackLink implements AnalyticsEvent {
  /* @inheritDoc */
  public eventInfo: EventInfo = {
    key: 'exitlink-fallback',
    eventName: 'Exit link from SelfReaccommodation'
  };
}

export class RefundLink implements AnalyticsEvent {
  /* @inheritDoc */
  public eventInfo: EventInfo = {
    key: 'ClickGetRefundedButton',
    eventName: 'Get Refunded from Self-Reacc'
  };
}

/**
 * Interface for the analytics of AcsBackToMmbPresComponent
 */
export interface CustomBackToMmbPresAnalytics extends AnalyticsEvents {
  exitLinkWithDeepLink: ConstructorAnalyticsEvent<ExitLinkWithDeepLink>;
  exitLinkWithFallbackLink: ConstructorAnalyticsEvent<ExitLinkWithFallbackLink>;
  refundLink: ConstructorAnalyticsEvent<RefundLink>;
}

/**
 * Definition of the analytics of AcsBackToMmbPresComponent
 */
export const customAnalyticsEvents: CustomBackToMmbPresAnalytics = {
  exitLinkWithDeepLink: ExitLinkWithDeepLink,
  exitLinkWithFallbackLink: ExitLinkWithFallbackLink,
  refundLink: RefundLink
};
